import { render } from "./FiltersLoop.vue?vue&type=template&id=b1365784&scoped=true"
import script from "./FiltersLoop.vue?vue&type=script&lang=js"
export * from "./FiltersLoop.vue?vue&type=script&lang=js"

import "./FiltersLoop.vue?vue&type=style&index=0&id=b1365784&scoped=true&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1365784"]])

export default __exports__